(function() {
    'use strict';

    angular
        .module('appback')
        .factory('CarrierService', CarrierService);

    CarrierService.$inject = ['$http'];

    function CarrierService($http) {

        var service = {

            getCarriers: getCarriers,
            submitShipment: submitShipment,
            getTracking: getTracking,
            getHistory: getHistory,
            getEtiqueta: getEtiqueta


        };

        function getEtiqueta(type, id, tracking) {
            var params = {
                material_id: id,
                type: type
            };
            if (tracking) {
                params.tracking = tracking;
            }
            return $http.get('/backend/carrier/etiqueta', { params: params });

        }

        function submitShipment(data, carrier, id) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                shipment: JSON.stringify(data),
                carrier_id: carrier.id,
                material_id: id
            });

            return $http.post('/backend/carrier/submit-shipping', data, config);
        }


        function getCarriers() {
            return $http.get('/backend/carrier/get-carriers');

        }
        function getHistory(type, materialId, tracking) {
            var params = { type: type, material_id: materialId };
            if (tracking) {
                params.tracking = tracking;
            }
            return $http.get('/backend/carrier/get-history', { params: params });
        };

        function getTracking(carrierId, materialId, reference) {

            var params = {
                carrier_id: carrierId,
                reference: reference,
                material_id: materialId
            };
            return $http.get('/backend/carrier/get-tracking', { params: params });

        }

        return service;


    }
})();
